class RegisterController extends AbstractEntityEditController
	@register()
	@inject '$scope',
		'translate'
		'ConfigurationService'
		'EntityAttributeService'
		'InfrasecRegisterService'
		'TokenGeneratorService'
		'ToastService'
		'MessageTerminal'
		'MessageTypes'
		'RegisterRepository'
		'RenderRepository'
		'ShopRepository'
		'register'
		'device'
		'shops'
		'layoutTemplates'
		'latestEOD'
		'hasOpenDayTally'
		'typeEnum': 'BACKEND_REGISTER_ENTITY_TYPE'
		'BACKEND_TRANSACTION_PAYMENT_TYPE'

	initialize: ->
		@mainCrud.entityTitle = 'wbo.new.register'
		@mainCrud.entityType = 'general.register'
		@mainCrud.parent_form.$setPristine()

		@isLayoutTemplatesVisible = @ConfigurationService.isEnabled 'Backoffice.Permission.LayoutTemplates.Enabled'
		@showConfigString = @ConfigurationService.isEnabled('Backoffice.RegisterManagement.EnableConfigurationString') &&
			angular.isDefined @register.id

		@InfrasecRegisterService.init(@register)
		@originRegister = null
		@isBaseRegisterType = true
		@types = _.chain(angular.copy(@typeEnum))
			.without @typeEnum.REGISTER
			.map (type) =>
				return {
					label_text: @translate('general.register.type.' + type.toLowerCase())
					entity_type: type
				}
			.value()

		@tabs = [
			{
				active: true
				title: 'wbo.tab.details'
				selector: '#tab-details'
			}
			{
				title: 'eod.title'
				selector: '#tab-eod-details'
				inactive: _.isEmpty @latestEOD
				disabled: angular.isUndefined @register.id
			}
		]

		if angular.isDefined @register.id
			@originRegister = angular.copy @register
			@mainCrud.isNewEntity = false
			@mainCrud.entityTitle = @register.name
			@checkRegisterType()

			if !@register.layout_template_id?
				@register.layout_template_id = @register.shop?.layout_template_id

			if @register.shop_id && !_.find(@shops, {id: @register.shop_id})
				@register.shop_id = null

			if !_.isEmpty @latestEOD
				@generateReport @latestEOD
		else
			@mainCrud.isNewEntity = true
			@register = {}

		@attributesService = @EntityAttributeService.getNewInstance()
		@attributesService.setEntity(
			@register
			'BACKEND_REGISTER_ATTRIBUTE_TYPE'
			{
				infrasec_external_register_id: null
			}
		)
		@InfrasecRegisterService.settings.has_ccuid = @attributesService.hasAttribute('infrasec_external_register_id')

		if @isBaseRegisterType
			@InfrasecRegisterService.status()

		if !@register.entity_type?
			@register.entity_type = @typeEnum.POS

		@InfrasecRegisterService.attributesService = @attributesService

	save: ->
		if @mainCrud.isNewEntity
			if @register.entity_type != @typeEnum.POS
				@attributesService.removeAttribute 'infrasec_external_register_id'

			@register.infrasec_auto_enroll = @InfrasecRegisterService.settings.auto_enroll

		@attributesService.persistAttributes()

		@RegisterRepository
			.save @register, @mainCrud.isNewEntity
			.then (response) =>
				response.data.shop = _.find @shops, {id: response.data.shop_id}
				@originRegister = response.data

				# Update configString with new info if it was generated
				if !@mainCrud.isNewEntity && angular.isDefined(@configString)
					@generateToken true

				@afterSave(response)
			.catch (response) =>
				@handleErrors response

	delete: ->
		@deleteEntity(@RegisterRepository, @register)

	generateToken: (refresh = false) ->
		if !refresh && angular.isDefined @configString
			return @configString

		# Use not UI changed register info
		@TokenGeneratorService
			.getToken @originRegister
			.then (token) =>
				@configString = token

	checkRegisterType: ->
		baseRegisterTypeIds = [
			@typeEnum.POS,
			@typeEnum.REGISTER
		]

		@isBaseRegisterType = baseRegisterTypeIds.includes @register.entity_type
		@isKDSRegister = @register.entity_type == @typeEnum.KDS

		if @isBaseRegisterType
			@InfrasecRegisterService.status()

	generateReport: (latestEOD) ->
		latestEOD.report = null

		report = _.find(latestEOD.subTotals, {key: @BACKEND_TRANSACTION_PAYMENT_TYPE.CASH})?.values

		if !report
			return

		for values in report
			if !values.balance? && !values.start? && !values.end?
				return

		latestEOD.report = report

	removeFromDevice: ->
		@RegisterRepository
			.removeFromDevice(@register.id)
			.then =>
				@register.device_id = null
				@device = {}
